"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const helpers_1 = require("./helpers");
function FetchValueComponent(props) {
    const apiCall = props.apiCall;
    const update = props.update;
    const log = props.log;
    const [value, setvalue] = react_1.default.useState(null);
    react_1.default.useEffect(() => {
        (0, helpers_1.ApiCallHandler)(apiCall, setvalue, log !== null && log !== void 0 ? log : 'Fetch Component', log ? true : false);
    }, [update]);
    return value;
}
exports.default = FetchValueComponent;
